import React, { Component } from "react";
import { connect } from "react-redux";
// import AppStore from "../../contexts/ecwid/StoreContext";
import { ISubscriptionState, mapSubscriptionStateToProps } from "../../redux/reducers/subscription";
import { ISubscriptionActionDispatches, mapSubscriptionDispatchToProps } from "../../redux/actions/subscription";
import AppStore, { IOrder, ICartItem, IProduct, ICart, SUBSCRIPTION_PRODUCT_ID } from "./StoreContext";
import { withAuth, IAuthProps } from "../../laco-common/auth/AuthContext";
import { waitForElements, waitForElement } from "../../utils";
import UILoader from "../ui/UILoader";
import "./EcwidOverrides.scss";
import "./SubscriptionCheckout.scss";

(window as any).ec = (window as any).ec || Object();
(window as any).ec.config = (window as any).ec.config || Object();
(window as any).ec.config.navigation_scrolling = "DISABLED";

const STORE_CONTAINER_ID: string = "ecwid-store-payment-container";

type SubscriptionCheckoutState = {
	loading: boolean;
	product: IProduct;
};

class SubscriptionCheckout extends Component<
	IAuthProps & ISubscriptionActionDispatches & ISubscriptionState,
	SubscriptionCheckoutState
> {
	state = {
		loading: true,
		product: null,
	};

	componentDidMount() {
		this.init();
	}

	init() {
		AppStore.initStore(STORE_CONTAINER_ID, this.onStoreLoaded.bind(this));
	}

	onStoreLoaded() {
		const email: string = this.props.authContext.userPayload.email;
		// const entity: IEntityUserData = this.props.entityUserData;
		AppStore.onOrderComplete(this.onOrderComplete.bind(this));

		// set product id by entity
		const productId: number = SUBSCRIPTION_PRODUCT_ID;
		console.debug(productId);
		// AppStore.clearCart();
		AppStore.setCustomerEmail(email);
		// AppStore.setCustomerAddress({name:})
		// AppStore.setOrderComments()
		AppStore.addToCartWithOptions(
			productId,
			{
				UserUid: this.props.authContext.uid,
				Email: email,
				// PageType: entity.entityType,
				// PageId: entity.id,
			},
			(success: boolean, product: IProduct, cart: ICart) => {
				console.log("addToCartWithOptions() success, product, cart:", product, cart);
				if (success) {
					AppStore.setCustomerEmail(email);
					AppStore.goToCheckout(false, () => {
						AppStore.setCustomerEmail(email);
						this.setState({ loading: false, product });

						// waitForElements(".ec-radiogroup__item", (radioOpts)=> {

						// })
						// waitForElements(".paypal-button", (paypalBtns: HTMLElement[]) => {
						// 	paypalBtns.forEach((el: HTMLElement) => {
						// 		el.style.borderRadius = "0px";
						// 	});
						// });
					});

					// AppStore.goToFinalCheckout();
					// AppStore.displayStore();this.setState({ loading: false });

					// const paymentUrl: string = AppStore.getPaymentPageUrl(cart);
					// console.debug(paymentUrl);
					// this.setState({ paymentUrl });
					// this.setState({ paymentUrl: "https://store16588572.ecwid.com/?checkout&orderId=85814392&cartId=B1B9CC68-74DF-4D52-A058-E3783364B7BA#!/~/checkoutPD" });
					// process.env.REACT_APP_ECWID_STORE_ID
					// AppStore.goToCheckout(STORE_CONTAINER_ID);
					// AppStore.goToFinalCheckout();
					// TODO: handle error

					setTimeout(() => {
						AppStore.setCustomerEmail(email);
						// AppStore.onOrderComplete(this.onOrderComplete.bind(this));
						// AppStore.goToFinalCheckout();
						// AppStore.goToCheckout(STORE_CONTAINER_ID);
						// this.setState({ loading: false });
					}, 200);
				}
			}
		);
	}

	onOrderComplete(order: IOrder) {
		console.debug("onOrderComplete", order);
		this.props.onOrderComplete(order, this.props.authContext);
		waitForElements(".ec-confirmation__section", (confirmMsgs: Element[]) => {
			confirmMsgs.forEach((el: Element) => {
				if (el.innerHTML.includes("queued for processing")) {
					el.innerHTML = "Your order has been placed and your subscription is now active.";
				}
			});
		});
	}

	render() {
		return (
			<div
				className="container ecwid-overrides app-payment-checkout section-padding pb-3"
				style={{ minHeight: "30vh" }}
			>
				{/* <div id="ecwid_product_browser_scroller"></div> */}
				{/* <h1 className="mb-4 highlighted">Checkout</h1> */}
				{!!this.state.product && <h2 className="mb-4">{this.state.product.name}</h2>}
				{this.state.loading && <UILoader display={true} />}
				<div id={STORE_CONTAINER_ID} style={this.state.loading ? { visibility: "hidden" } : {}}></div>
			</div>
		);
	}
}

// onPaymentComplete(order?: IOrder): Promise<any> {
//     console.debug("onPaymentComplete");
//     let newStatus: EntityStatus = EntityStatus.PENDING;
//     if (UserService.autoApprovePublish) {
//         newStatus = EntityStatus.ACTIVE;
//     }
//     const entity: IEntity = { ...this.getUpdatedEntity(), status: newStatus };
//     let updatedEntityUserData: IEntityUserData = this.getUpdatedEntityUserData();
//     if (order) {
//         updatedEntityUserData.orderIds = (updatedEntityUserData.orderIds || []).concat([order.vendorNumber]);
//         updatedEntityUserData.orderNumbers = (updatedEntityUserData.orderNumbers || []).concat([order.orderNumber]);
//         updatedEntityUserData.paymentStatus = PaymentStatus.PAID;
//     } else {
//         updatedEntityUserData.paymentStatus = PaymentStatus.NOT_REQUIRED;
//     }

//     const entityUserData: IEntityUserData = {
//         ...updatedEntityUserData,
//         status: newStatus
//     };

//     return this.doSave(entity, entityUserData, true).then(() => {
//         this.props.entityProps.publish(entityUserData);
//     });
// }

export default connect<ISubscriptionState, ISubscriptionActionDispatches>(
	mapSubscriptionStateToProps,
	mapSubscriptionDispatchToProps
)(withAuth(SubscriptionCheckout));
